<template>
  <v-dialog v-model="dialogModel" max-width="550" persistent>
    <v-card class="py-6 px-10 text-center">
      <lottie
        :options="defaultOptions"
        :height="130"
        :width="130"
        class="lottie-left"
        :style="enableOtp ? { left: '-10px' } : {}"
      />

      <template v-if="enableOtp">
        <div class="mb-2 text-h6 font-weight-bold">
          If your email account is valid, you will receive an OTP code.
        </div>
        <div v-if="maskedEmail" class="email-box my-4">
          <span class="teal--text text--darken-2 font-weight-medium">Sent to {{ maskedEmail }}</span>
        </div>
        <div class="text-body-2 mb-4">
          Please check your inbox or spam folder.
        </div>
      </template>

      <template v-else >
        
        
        <div class="my-2 text-h6 font-weight-bold">
          Your registered email is
          <span class="blue--text font-weight-bold">{{ userData?.data?.email }}</span><br />
          Please check if your email is active
        </div>

        <div class="bordered-box my-6">
        
          <div class="mb-6 text-h8  text-start">
            We are implementing OTP authentication which will be sent to your email starting
            <span class="blue--text font-weight-bold">July 1, 2025</span>
          </div>
  
            <div class="text-body-2 text-start">
              If your email is invalid, please contact:
              <div class="mt-2 d-flex align-start justify-start flex-column">
                <div class="d-flex align-center mb-1">
                  <v-icon left small color="primary">mdi-email</v-icon>
                  <span class="blue--text">merchantcare@bni.co.id</span>
                </div>
                <div class="d-flex align-center">
                  <v-icon left small color="primary">mdi-phone</v-icon>
                  <span class="blue--text">1500146</span>
                </div>
              </div>
            </div>
          </div>
      </template>

      <v-btn color="primary" dark @click="handleOk">OK</v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
import Lottie from 'vue-lottie';
import emailAnimationData from '../../../assets/email-otp.json';
import alertAnimationData from '../../../assets/alert-otp.json'; 
import { date } from '../../../lib/helpers';

export default {
  name: 'OtpConfirmationDialog',
  components: {
    Lottie
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    userData: {
      type: Object,
      default: () => {}
    }
  },
  watch: {
    dialogModel(val) {
      if (val) {
        window.addEventListener('keydown', this.handleEnterKey);
      } else {
        window.removeEventListener('keydown', this.handleEnterKey);
      }
    }
  },

  beforeDestroy() {
    window.removeEventListener('keydown', this.handleEnterKey);
  },
  computed: {
    enableOtp () {
      return this.userData.enableOtp === true;
    },
    maskedEmail () {
      return this.userData?.email || '';
    },
    animationData () {
      return this.enableOtp ? emailAnimationData : alertAnimationData;
    },
    defaultOptions () {
      return {
        animationData: this.animationData,
        autoplay: true
      };
    },
    dialogModel: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },
  methods: {
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.handleOk();
      }
    },
    handleOk() {
      this.dialogModel = false;
      if (this.enableOtp) {
        this.$router.push('/login-otp');
        return;
      }

      const payload = { payload: this.userData.data };
      this.$store.dispatch('set_login', payload);
      this.$store.dispatch('getNotif', { date });
    }
  }
};
</script>

<style scoped>
.lottie-left {
  position: relative;
}
.email-box {
  background-color: #e0f2f1;
  border-radius: 8px;
  padding: 12px 16px;
  display: inline-block;
}
.bordered-box {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
}

</style>
